import {Label} from "./../../models/Label";


let labelsApi = {
    async get(type, token, companyId, params={}){
        let response = await window.axios.get('/api/companies/'+companyId+'/labels', {
            params:{
                api_token:token,
                company_logged:companyId,
                type:type,
                ...params
            }
        });
        return response.data.map(l=>new Label(l));
    },

    async create(label, token, companyId){
        let response = await window.axios.post('/api/labels', label, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Label(response.data);
    },
    async edit(label, token, companyId){
        let response = await window.axios.put('/api/labels/'+label.id, label, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Label(response.data);
    },
    async delete(label, token, companyId){
        let response = await window.axios.delete('/api/labels/'+label.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
}

export default labelsApi